import { propEq, append, identity, ifElse } from 'ramda'

const isSelectedResourceInactive = selectedResource => {
  return selectedResource ? propEq('IsActive', false)(selectedResource) : false
}

const appendResource = selectedResourceObj => {
  return append({
    Description: selectedResourceObj.Description,
    Key: selectedResourceObj.Key,
    IsActive: false,
    $isDisabled: true,
  })
}

export const maybeAppendResource = ifElse(
  isSelectedResourceInactive,
  appendResource,
  () => identity,
)
